export enum ALLOCATION_REASONS {
    FIRST_DOWNLOAD = 'first_download',
    FREE_DOWNLOAD = 'fdl_bonus',
    PERSONALIZATION = 'personalization_per_half_year_reward'
}

export enum NOTIFICATIONS {
    CREDITS_ALLOCATED = 'credits_allocated'
}
